/* =========================================================
   AF FAQ Accordion — cached JS
   File: assets/af-faq-accordion.js

   Same behavior as af-ae-faq:
   - Optional single-open (closes others BEFORE opening next)
   - Click + keyboard toggle
   - Prevents double-binding on theme editor reloads
   - Event delegation
   ========================================================= */
(() => {
  "use strict";

  const roots = document.querySelectorAll("[data-af-faq]");
  if (!roots.length) return;

  roots.forEach((root) => {
    if (!root) return;
    if (root.dataset.afFaqInit === "1") return;
    root.dataset.afFaqInit = "1";

    const single = root.getAttribute("data-af-faq-single") === "true";
    const items = Array.from(root.querySelectorAll("details.af-faq__item"));
    if (!items.length) return;

    // If single-open: ensure only one open on load
    if (single) {
      const openOnLoad = items.filter((d) => d.hasAttribute("open"));
      if (openOnLoad.length > 1) openOnLoad.slice(1).forEach((d) => d.removeAttribute("open"));
    }

    const closeOthers = (except) => {
      for (let i = 0; i < items.length; i++) {
        const d = items[i];
        if (d !== except && d.hasAttribute("open")) d.removeAttribute("open");
      }
    };

    const toggleDetails = (d) => {
      const willOpen = !d.hasAttribute("open");
      if (single) closeOthers(d);
      if (willOpen) d.setAttribute("open", "");
      else d.removeAttribute("open");
    };

    root.addEventListener("click", (e) => {
      const summary = e.target && e.target.closest ? e.target.closest("summary.af-faq__q") : null;
      if (!summary || !root.contains(summary)) return;

      const d = summary.closest("details.af-faq__item");
      if (!d) return;

      e.preventDefault();
      toggleDetails(d);
    });

    root.addEventListener("keydown", (e) => {
      const key = e.key;
      if (key !== "Enter" && key !== " ") return;

      const summary = e.target && e.target.closest ? e.target.closest("summary.af-faq__q") : null;
      if (!summary || !root.contains(summary)) return;

      const d = summary.closest("details.af-faq__item");
      if (!d) return;

      e.preventDefault();
      toggleDetails(d);
    });
  });
})();
